import { createStyles, makeStyles } from '@material-ui/core'

export const useReviewItemStyles = makeStyles((theme) =>
  createStyles({
    root: {
      paddingBottom: 19,
      '&:not(:last-child)': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
      },
      '&:not(:first-child)': {
        paddingTop: 11
      }
    },

    reviewTop: {
      display: 'flex',
      justifyContent: 'space-between'
    },

    reviewTopLeft: {
      display: 'flex',
      gap: 16
    },

    reviewAuthorAvatar: {
      width: 32,
      height: 32,
      borderRadius: '50%'
    },

    reviewAuthorName: {
      fontWeight: 500,
      [theme.breakpoints.down('xs')]: {
        maxWidth: 150
      }
    },

    reviewEstimate: {},

    reviewTopRight: {},

    reviewDate: {},

    reviewBody: {
      paddingLeft: 48
    },

    reviewText: {},

    reviewImagesPreviews: {
      marginTop: 7,
      display: 'flex',
      gap: 7
    },

    reviewImagePreview: {},

    lowScore: {
      color: '#E52428'
    },

    mediumScore: {
      color: '#FFBE2B'
    },

    highScore: {
      color: '#24C034'
    }
  })
)
